export default function IconApplicationStep5() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 64 56.146"
    >
      <path
        d="M64 11.518H46.675V8.156C46.675 3.66 43.016 0 38.519 0H25.48c-4.497 0-8.156 3.659-8.156 8.156v3.362H0v10.09c0 2.58.766 5.034 2.115 7.102v27.436h59.77V28.71A12.99 12.99 0 0 0 64 21.609v-10.09ZM5.864 32.478c.863.568 1.801 1.04 2.804 1.395l16.466 5.83v1.181c0 3.786 3.08 6.866 6.866 6.866s6.866-3.08 6.866-6.866v-1.18l16.466-5.83a12.947 12.947 0 0 0 2.804-1.396v19.918H5.864V32.478Zm23.02 8.406v-5.967h6.232v5.967C35.116 42.602 33.718 44 32 44s-3.116-1.398-3.116-3.116ZM54.08 30.34l-15.214 5.387v-4.56H25.134v4.56L9.92 30.339a9.277 9.277 0 0 1-6.17-8.73v-6.34h56.5v6.34a9.277 9.277 0 0 1-6.17 8.73ZM25.481 3.75H38.52a4.411 4.411 0 0 1 4.406 4.406v3.362h-21.85V8.156a4.411 4.411 0 0 1 4.406-4.406Z"
        data-name="Layer 1"
        style={{
          fill: "var(--color-primary)",
          strokeWidth: 0,
        }}
      />
    </svg>
  );
}
